import { useSyncExternalStore } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { api, ReportOrgan } from '@/api';
import { getReportOrgansMapFromCache } from '@/shared/util';
import { OrganName } from '@/store';

function isRelevantReportOrgansListCacheEvent(queryKey: readonly unknown[], reportUuid: string) {
  return queryKey[0] === api.fct.reportOrgan.KEY.GET_REPORT_ORGANS && queryKey[1] === reportUuid;
}

export function useReportOrgansMapFromQuery(
  reportUuid: string,
): Record<OrganName, ReportOrgan> | undefined {
  const queryClient = useQueryClient();

  return useSyncExternalStore(
    (onStoreChange) =>
      queryClient.getQueryCache().subscribe((event) => {
        if (event.type !== 'updated' && event.type !== 'added' && event.type !== 'removed') {
          return;
        }

        if (isRelevantReportOrgansListCacheEvent(event.query.queryKey, reportUuid)) {
          onStoreChange();
        }
      }),
    () => getReportOrgansMapFromCache(queryClient, reportUuid),
    () => getReportOrgansMapFromCache(queryClient, reportUuid),
  );
}
